import { render, staticRenderFns } from "./modal-merge-cart.vue?vue&type=template&id=39297cfa&scoped=true&"
import script from "./modal-merge-cart.vue?vue&type=script&lang=js&"
export * from "./modal-merge-cart.vue?vue&type=script&lang=js&"
import style0 from "./modal-merge-cart.vue?vue&type=style&index=0&id=39297cfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39297cfa",
  null
  
)

export default component.exports